import { useState, useEffect } from "react";
import PageLayout from "../../../layouts/PageLayout";
import { Row, Col, Card, Accordion, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaRegEdit } from "react-icons/fa";
import axiosInstance from "../../../context/axiosInstance";
import { BsHurricane } from "react-icons/bs";
import axios from "axios";
import BrickTableComponent from "../../../components/tables/BrickTableComponent";

export default function AllBrickKilns() {
  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
  const [formState, setFormState] = useState({});
  const [brickkilnss, setBrickkilns] = useState([]);
  const [cities, setCities] = useState();
  const [designation, setDesignation] = useState();
  const [state, setState] = useState({
    cityName: "",
    designationName: "",
  });
  //   const handleChange = (e) => {
  //     const { name, value, type, files } = e.target;
  //     if (type === "file") {
  //       setFormState((prevState) => ({
  //         ...prevState,
  //         [name]: files[0],
  //       }));
  //     } else {
  //       setFormState((prevState) => ({
  //         ...prevState,
  //         [name]: value,
  //       }));
  //     }
  //   };

  //   const handleSubmit = (e) => {
  //     e.preventDefault();
  //     console.log(formState);
  //   };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_URL + "/list-brickkilns");

        setBrickkilns(response.data.brickkilns);


      } catch (error) {
        console.error("Error While Fetching Data", error);
      }
    };
    fetchData();
  }, []);



  const mappedData = brickkilnss.map((brickkiln) => ({
    id: brickkiln.id,
    brickkiln_name: brickkiln.brickkiln_name || "",
    owner: brickkiln.brickkiln_owner || "",
    cnic: brickkiln.owner_cnic || "", // Assuming the same name
    conatct: brickkiln.brickkiln_owner_cell || "",
    city: brickkiln.city?.name, // Static value, replace if dynamic
    action: {
      edit: "edit",
      view: "visibility",
    },
  }));
  return (
    <PageLayout style={{ height: "100%" }}>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                <i className="material-icons">factory</i>
                All Brick Kilns
              </h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="/" className="mc-breadcrumb-link"style={{color:"#077834"}}>
                    Home
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">All Brick Kilns</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <BrickTableComponent
            thead={['Brick Kiln Name', 'Owner', "CNIC", 'Contact', 'City', "Action"]}
            tbody={mappedData}
          />
        </Col>
      </Row>
    </PageLayout>
  );
}
